import script from "./DataLicenseSave.vue?vue&type=script&setup=true&lang=js"
export * from "./DataLicenseSave.vue?vue&type=script&setup=true&lang=js"

import "./DataLicenseSave.vue?vue&type=style&index=0&id=8cfa5b74&lang=postcss"

const __exports__ = script;

export default __exports__